export type CategoryItem = {
  type: string;
  name: string;
  nameEn: string;
  description: string;
  icon: string;
};

export const categories: CategoryItem[] = [
  {
    type: "classic",
    name: "经典典藏",
    nameEn: "Classics",
    description:
      "收录 2000 至 2015 年间具有代表性的日韩情感电影，包含修复重映与影史留名的作品，适合想系统了解这一时期创作脉络的观众。",
    icon: "ri-video-line",
  },
  {
    type: "recent",
    name: "近期新片",
    nameEn: "New Releases",
    description:
      "2023 年之后上映或首映的日韩新作，聚焦当下创作者对亲密关系的全新表达，片单持续更新。",
    icon: "ri-flashlight-line",
  },
  {
    type: "popular",
    name: "热门排行",
    nameEn: "Popular",
    description:
      "根据站内浏览与评分综合排序的高关注度作品，是初次访问时最省力的入口。",
    icon: "ri-fire-line",
  },
  {
    type: "themes",
    name: "多元题材",
    nameEn: "Themes",
    description:
      "按剧情、浪漫、悬疑、心理、文艺等主题标签组织的专题片单，你可以在这里按心情挑片。",
    icon: "ri-bookmark-3-line",
  },
  {
    type: "japan",
    name: "日系精选",
    nameEn: "Japanese Selection",
    description:
      "以留白、光影与季节感见长的日本作品集合，包含文艺长片与实验性短片。",
    icon: "ri-sun-line",
  },
  {
    type: "korea",
    name: "韩系佳作",
    nameEn: "Korean Selection",
    description:
      "关注都市空间与人物关系的韩国作品集合，夜戏、雨景与长镜头是其鲜明标签。",
    icon: "ri-moon-line",
  },
];

export const categoryFallback: CategoryItem = {
  type: "themes",
  name: "多元题材",
  nameEn: "Themes",
  description:
    "按剧情、浪漫、悬疑、心理、文艺等主题标签组织的专题片单，你可以在这里按心情挑片。",
  icon: "ri-bookmark-3-line",
};

export const yearRanges = [
  { label: "全部年份", value: "all" },
  { label: "2020 - 2026", value: "2020s" },
  { label: "2015 - 2019", value: "2010s-late" },
  { label: "2010 - 2014", value: "2010s-early" },
  { label: "2009 及以前", value: "before-2010" },
];

export const genreTags = [
  "剧情",
  "浪漫",
  "文艺",
  "悬疑",
  "心理",
  "都市",
  "青春",
  "禁忌",
  "激情",
  "爱情",
];

export const lengthOptions = [
  { label: "全部片长", value: "all" },
  { label: "长片（90 分钟以上）", value: "长片" },
  { label: "短片（60 分钟以内）", value: "短片" },
];

export const regionOptions = [
  { label: "全部地区", value: "all" },
  { label: "日本", value: "日本" },
  { label: "韩国", value: "韩国" },
];